import { inject, Injectable } from '@angular/core';
import { AppConfigService } from '@markant-platform/shared/data-access';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuditEntryDto, AuditRequest } from './model/audit.model';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  private readonly apiUrl: string = AppConfigService.appConfiguration.apiUrl['auditService'];

  private readonly http: HttpClient = inject(HttpClient);

  /**
   * Receives a list of audit entries for a certain entity.<br/>
   * The data will already provide a parsed object by default.
   * @returns A list of audit entries as observable
   * @param data
   */
  getAuditEntriesByContext({
    context,
    entitiesNumber,
    toDate,
    filters,
    entityTypes,
    query,
  }: AuditRequest): Observable<AuditEntryDto[]> {
    let params = new HttpParams().set('context', this.buildContextQuery(context)).set('limit', entitiesNumber);

    if (toDate) {
      params = params.set('to', toDate);
    }

    if (filters && Object.keys(filters).length) {
      params = params.appendAll(filters);
    }

    if (entityTypes && entityTypes.length) {
      params = params.appendAll({ type: entityTypes });
    }

    if (query) {
      params = params.set('query', query);
    }

    return this.http.get<AuditEntryDto[]>(`${this.apiUrl}`, { params });
  }

  private buildContextQuery(context: Record<string, string>): string {
    return Object.entries(context)
      .map(([k, v]) => `${k}:${v}`)
      .join(',');
  }
}
